/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reloadpage1Inputs */

const en_reloadpage1 = /** @type {(inputs: Reloadpage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reload Page`)
};

const de_reloadpage1 = /** @type {(inputs: Reloadpage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seite neu laden`)
};

/**
* | output |
* | --- |
* | "Reload Page" |
*
* @param {Reloadpage1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const reloadpage1 = /** @type {((inputs?: Reloadpage1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reloadpage1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reloadpage1(inputs)
	return de_reloadpage1(inputs)
});
export { reloadpage1 as "reloadPage" }